/* eslint-disable */
import React, {useCallback, useEffect, useRef, useState} from 'react';
import {useTranslation} from "react-i18next";
import {schema} from "@/features/user/contactInfo/validations";
import {makeRequired, makeValidate} from "mui-rff";
import {makeYupTranslatedError} from "@/helpers/yup";
import {TContactInfoForm} from "@/features/user/contactInfo/types";
import ContactInfoForm from "@/features/user/contactInfo/components/form";
import {MenuItem} from "@mui/material";

const ContactInfo = ({isModal, closePopover, from = "Route"}: any): any => {
    //console.log("@ContactInfo loading component from ", from);

    const [t] = useTranslation();

    const [loading, setLoading] = useState(true);

    // to know if modal is open
    const [modalOpen, setModalOpen] = useState(false);

    const [submitting, setSubmitting] = useState(false);

    const initialValues: any = {
        phone: '',
        fax_number: '',
        email: '',
        aux_email_1: '',
        aux_email_2: '',
        webpage: ''
    };
    const initialValuesRef = useRef<any>(initialValues);

    const validateForm = makeValidate(schema, makeYupTranslatedError);

    const required = makeRequired(schema);

    const getData = useCallback(async () => {
        // set loader
        setLoading(true);
        
        // TODO: get data from contact
        
        setLoading(false);
    }, []);

    // yes, this can even be async!
    const onSubmit = async (values: any) => {
        setSubmitting(true);
        //console.log('values', values);
        setSubmitting(false);
        return true;
    };

    useEffect(() => {
        if (!isModal)
            getData().catch((e) => console.error(e));
    }, []);

    useEffect(() => {
        //console.log("@ContactInfo sensing value modalOpen: ", modalOpen);
        if (modalOpen) {
            //console.log("@ContactInfo modal is open and not loaded data first time");
            getData().catch((e: any) => console.error(e));
        }
    }, [modalOpen])

    const formProps: TContactInfoForm = {
        onSubmit,
        initialValues: initialValuesRef.current,
        validateForm,
        required,
        submitting,
        isModal,
        closePopover,
        setModalOpen,
        loading
    }

    return (
        <>
            {<ContactInfoForm {...formProps} />}

            {/*{(loading && !isModal) && <>{t('common.loading')}</>}

            {(loading && isModal) && <MenuItem>{t('contact_info.title')}</MenuItem>}*/}
        </>
    );
}

export default ContactInfo;
